import { SxProps, Theme } from '@mui/material';
import { ZIndex } from '@/utils/zIndex';

export const modalRootSX: SxProps<Theme> = { zIndex: ZIndex.HIGHEST };

export const modalSX: SxProps<Theme> = { padding: 0 };

export const dialogContainerSX: SxProps<Theme> = {
	backgroundColor: '#FFFFFF',
	position: 'absolute',
	overflow: 'auto',
	height: 'auto',
	top: { xs: 'auto', sm: '50%' },
	bottom: { xs: 0, sm: 'auto' },
	left: { xs: 0, sm: '50%' },
	right: { xs: 0, sm: 'auto' },
	transform: { xs: 'none', sm: 'translate(-50%, -50%)' },
	width: { xs: '100%', sm: '470px' },
	maxWidth: { xs: '100%', sm: 'calc(100vw - 32px)' },
	maxHeight: { xs: '90dvh', sm: '90vh' },
	borderRadius: { xs: '4px 4px 0 0', sm: '4px' },
	padding: { xs: '34px 26px 36px', sm: '38px 34px 35px' },
	boxSizing: 'border-box',
	outline: 'none',
};

export const closeButtonSX: SxProps<Theme> = {
	position: 'absolute',
	right: { xs: '7px', sm: '8px' },
	top: { xs: '7px', sm: '8px' },
	fontSize: '24px',
	color: '#1F1F1F',
	padding: '4px',
	'&:hover': {
		backgroundColor: 'transparent',
		color: '#1F1F1F',
	},
};

export const contentSX: SxProps<Theme> = {
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	fontFamily: 'Open Sans, Helvetica Neue, Arial, sans-serif',
};

export const titleSX: SxProps<Theme> = {
	color: '#2C2C2C',
	fontFamily: 'Open Sans, Helvetica Neue, Arial, sans-serif',
	fontSize: { xs: '21px', sm: '22px' },
	fontWeight: 800,
	lineHeight: '26px',
	textAlign: 'center',
	margin: 0,
	textTransform: 'uppercase',
};

export const descriptionSX: SxProps<Theme> = {
	color: '#111111',
	fontFamily: 'Open Sans, Helvetica Neue, Arial, sans-serif',
	fontSize: '14px',
	fontWeight: 400,
	lineHeight: '20px',
	textAlign: 'center',
	margin: { xs: '5px 0 15px', sm: '6px 0 17px' },
	maxWidth: { xs: '280px', sm: '300px' },
};

export const descriptionHighlightSX: SxProps<Theme> = {
	color: '#AB2326',
	fontWeight: 700,
};

export const productCardSX: SxProps<Theme> = {
	display: 'flex',
	alignItems: 'center',
	gap: '14px',
	width: '100%',
	backgroundColor: '#F7F7F7',
	borderRadius: '3px',
	padding: { xs: '10px', sm: '10px 14px' },
	boxSizing: 'border-box',
	'& > a': {
		display: 'flex',
		flex: '0 0 auto',
	},
};

export const imageFrameSX: SxProps<Theme> = {
	width: { xs: '81px', sm: '78px' },
	height: { xs: '81px', sm: '82px' },
	backgroundColor: '#D8D8D8',
	flex: '0 0 auto',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	overflow: 'hidden',
};

export const imageSX: SxProps<Theme> = {
	width: '100%',
	height: '100%',
	objectFit: 'contain',
	display: 'block',
};

export const productInfoSX: SxProps<Theme> = {
	display: 'flex',
	flexDirection: 'column',
	gap: '6px',
	minWidth: 0,
	'& > a': {
		color: 'inherit',
		textDecoration: 'none',
		minWidth: 0,
	},
};

export const productNameSX: SxProps<Theme> = {
	color: '#2C2C2C',
	fontFamily: 'Open Sans, Helvetica Neue, Arial, sans-serif',
	fontSize: '14px',
	fontWeight: 600,
	lineHeight: '18px',
	margin: 0,
};

export const productCategorySX: SxProps<Theme> = {
	color: '#505050',
	fontSize: '14px',
	whiteSpace: 'nowrap',
	overflow: 'hidden',
	textOverflow: 'ellipsis',
};

export const priceRowSX: SxProps<Theme> = {
	display: 'flex',
	gap: '6px',
	alignItems: 'center',
};

export const discountPriceSX: SxProps<Theme> = {
	color: '#AB2326',
	fontSize: '15px',
	fontWeight: 600,
};

export const priceSX = (hasDiscount: boolean): SxProps<Theme> => ({
	color: '#2C2C2C',
	fontSize: '15px',
	fontWeight: hasDiscount ? 400 : 600,
	textDecoration: hasDiscount ? 'line-through' : 'none',
});

export const productPriceSX: SxProps<Theme> = {
	color: '#111111',
	fontFamily: 'Open Sans, Helvetica Neue, Arial, sans-serif',
	fontSize: '14px',
	fontWeight: 600,
	lineHeight: '18px',
	margin: 0,
};

export const actionsSX: SxProps<Theme> = {
	display: 'flex',
	flexDirection: 'column',
	gap: '10px',
	width: '100%',
	marginTop: { xs: '18px', sm: '18px' },
};

export const primaryButtonSX: SxProps<Theme> = {
	minHeight: '42px',
	fontSize: '14px',
	fontWeight: 800,
	lineHeight: '18px',
	textTransform: 'none',
};

export const secondaryButtonSX: SxProps<Theme> = {
	minHeight: '42px',
	fontSize: '14px',
	fontWeight: 800,
	lineHeight: '18px',
	textTransform: 'none',
};
